import { Injectable } from "@angular/core";
import { TranslationService } from "./translation.service";

@Injectable()
export class LanguageService {
  constructor(private translationService: TranslationService) {}
  public isGrownUpLayer(layer: string): boolean {
    const grownUps = this.translationService.currentTranslations.grownUpLayer;
    return grownUps.includes(layer);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/language.service.ts